import React from 'react';

function ExpertsCardsWebinar(props) {
  const { id, name, profilePic, qualifications, bio, showBio } = props;
  return (
    <div className={'expertCards'}>
      <img src={profilePic} className={'expertProfilePic'} />
      {bio && showBio && (
        <div className={'expertBio'}>
          <div className={'expertBioTitle'}>About {name} :</div>
          {bio}
        </div>
      )}
      <div className={'expertDetails'}>
        <div className={'expertName'}>{name}</div>
        <div className={'expertQualification'}>{qualifications}</div>
      </div>
    </div>
  );
}

export default ExpertsCardsWebinar;
